'use client'

import { AnalyticsEvents } from 'analytics/constants/events'
import { CustomEventTypes } from 'analytics/types/CustomEvent'
import { startGTM } from 'analytics/utils/startGTM/startGTM'
import { useEffect } from 'react'
import { PageType } from 'types/analytics'
import { env } from 'utils/envManager'

import { Dynatrace } from './components/Dynatrace/Dynatrace'

const ANALYTIC_ERROR_500_EVENT = '500'

export default function Template({
	children,
}: {
	readonly children: React.ReactNode
}): React.ReactNode {
	useEffect(() => {
		const language = navigator.language?.split('-')?.[0] || 'unknown'
		window.dataLayer = window.dataLayer ?? []
		startGTM()
		window.dataLayer.push({
			event: AnalyticsEvents.LOAD_DATALAYER,
			page_type: PageType.Error500,
			environment: env.NEXT_PUBLIC_ENV,
			language_iso: language,
			// TODO: webview on apps
			is_app: false,
			application: env.NEXT_PUBLIC_CHANNEL,
			error: ANALYTIC_ERROR_500_EVENT,
		})
		window.dataLayer.push({
			event: `${CustomEventTypes.GENERIC}-${ANALYTIC_ERROR_500_EVENT}`,
			event_name: AnalyticsEvents.ERROR_500,
			error: ANALYTIC_ERROR_500_EVENT,
		})
	}, [])

	return (
		<>
			<Dynatrace />
			{children}
		</>
	)
}
